module.exports = __webpack_public_path__ + "img/www.expedia.com.9bc753ee.png";